import React from 'react';
import { connect } from 'react-redux';

import * as Types from 'types';
import { PlaylistFilter } from 'playlists/components/PlaylistFilter';

import { setArtStreamArtworksFilter } from 'features/playlists/actions';

type Props = {
  setArtStreamArtworksFilter: (filter: string) => void;
  initialFilter: string;
} & Types.Styleable;

const ArtStreamArtworksFilter = (props: Props) => (
  <PlaylistFilter
    className={props.className}
    style={props.style}
    onChange={props.setArtStreamArtworksFilter}
    placeholderText='Search'
    initialFilter={props.initialFilter}
  />
);

const mapStateToProps = (state: Types.RootState) => ({
  initialFilter: state.playlists.artStreamArtworksFilter,
});

const mapDispatchToProps = {
  setArtStreamArtworksFilter,
};

export const ArtStreamArtworksFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArtStreamArtworksFilter);
